/**
 *Styles
 */
import "./ButtonGroup.scss";

const ButtonGroup = ({ cbStepNext, cbStepBack }) => {
  const handlerStepBack = () => {
    if (cbStepBack) {
      cbStepBack();
    }
  };

  const handlerStepNext = () => {
    if (cbStepNext) {
      cbStepNext();
    }
  };

  return (
    <div className="button__wrapper">
      <button className="back" onClick={handlerStepBack}>
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.4 12.5L3.8 8.99998H16V6.99998H3.8L7.4 3.49998L5.9 2.09998L0 7.99998L5.9 13.9L7.4 12.5Z"
            fill="#111212"
          />
        </svg>
        <span>Back</span>
      </button>
      <button onClick={handlerStepNext} className="next">
        <span>Next</span>
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8.6 3.49998L12.1 6.99998H0V8.99998H12.1L8.6 12.5L10 13.9L16 7.99998L10 2.09998L8.6 3.49998Z"
            fill="white"
          />
        </svg>
      </button>
    </div>
  );
};
export default ButtonGroup;
